import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import ArrowIcon from "./arrow.svg";

export type ContainerProps = {
  $isActive: boolean;
  $withoutDetail: boolean;
};

export const Title = styled.div`
  margin-block-end: 8px;

  font-weight: 700;
  font-size: 18px;
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  gap: 12px;

  inline-size: 340px;
  padding: 12px;

  border-radius: 8px;

  background: #ffffff;

  cursor: pointer;

  transform: none;

  &:hover ${Title} {
    text-decoration: ${props => (props.$withoutDetail ? "none" : "underline")};
  }

  ${props =>
    props.$withoutDetail &&
    css`
      background: rgba(255, 255, 255, 0.2);

      cursor: default;
    `}

  ${props =>
    props.$isActive &&
    css`
      background: #d4e0f2;

      transform: translateX(8px);
    `}
`;

type DateContainerProps = {
  $isKeyEvent?: boolean;
};

export const Date = styled.div<DateContainerProps>`
  flex-shrink: 0;

  inline-size: 36px;

  color: ${props => (props.$isKeyEvent ? "#4585FF" : "#000000")};
  text-align: center;
`;

export const Day = styled.div`
  font-size: 24px;
`;

export const Month = styled.div`
  font-size: 12px;
  text-transform: uppercase;
`;

export const Detail = styled.div`
  flex-grow: 1;

  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const DetailRight = styled.div``;

export const DateDetail = styled.div`
  display: flex;
  gap: 8px;
`;
export const DateRange = styled.div`
  color: #333333;
  font-weight: 700;
  font-size: 13px;
`;
export const Separator = styled.div`
  color: #333333;
`;
export const Time = styled.div`
  color: #333333;
  font-size: 13px;
`;
export const Summary = styled.div`
  margin-block-start: 4px;

  color: #333333;
  font-size: 13px;
`;
export const More = styled.div``;
export const Arrow = styled(ArrowIcon)``;

export const UpdatedLabelContainer = styled.div`
  margin-block: 8px 8px;
`;
